<div class="bg-white">
  <div class="" [ngClass]="{'d-none': error}" [hidden]="!company">
    <app-header-company [company]="company" [mobilePosition]="scrollPositions"></app-header-company>
    <div class="container">
      <div class="row" #vancancyEl>
        <div class="col-12 col-md-4 d-none d-md-block menu-scroll">
          <app-sidebar [company]="company" [vacancyPosition]="scrollPositions" [mobile]="false"></app-sidebar>
        </div>
        <div class="col-12 col-md-8">
          <div class="d-block d-md-none">
            <img class="logo" [src]="company?.logo || 'assets/images/company/company-logo.png'" alt="">
          </div>

          <h1 [style.color]="company?.landingPage?.colors?.mainColor">{{company?.fantasyName}}</h1>

          <section *ngIf="hiddenPage" id="program">
            <h1 #program [style.color]="company?.hiddenLandingPage?.colors?.mainColor">
              {{ company?.hiddenLandingPage?.programName }}
            </h1>
            <div [innerHTML]="company?.hiddenLandingPage?.programDescription"></div>
          </section>

          <section id="description" *ngIf="hiddenPage && company?.landingPage?.indication?.about">
            <h3 #about [style.color]="company?.landingPage?.colors?.mainColor">DESCRIÇÃO DO PROGRAMA</h3>
            <div [innerHTML]="company?.hiddenLandingPage?.programDescription"></div>
          </section>

          <section id="howItWorks" *ngIf="hiddenPage">
            <h3 #howItWorks [style.color]="company?.landingPage?.colors?.mainColor">COMO FUNCIONA?</h3>
            <div [innerHTML]="company?.hiddenLandingPage?.howItWorks"></div>
          </section>

          <section class="mb-2">
            <h3 #vacancy *ngIf="hiddenPage" [style.color]="company?.hiddenLandingPage?.colors?.mainColor">
              Vagas
            </h3>
            <div class="d-flow-root" id="cardVacancies"
              *ngIf="!loadVacancies && company?.landingPage?.config?.showVacancies == true">
              <h2>{{company?.landingPage?.slogan}}</h2>

              <ng-container *ngIf="highlightVacancies.length">
                <h3 [style.color]="company?.landingPage?.colors?.mainColor">Vagas destacadas</h3>
                <app-cards [vacancies]="highlightVacancies" [companyKey]="company?.key"
                  [color]="company?.landingPage?.colors?.mainColor" [showOpportunity]="isPJOpportunity">
                </app-cards>
              </ng-container>

              <h3 [style.color]="company?.landingPage?.colors?.mainColor">Todas as vagas</h3>
              <app-cards [vacancies]="vacancies" [companyKey]="company?.key"
                [color]="company?.landingPage?.colors?.mainColor" [showOpportunity]="isPJOpportunity">
              </app-cards>

              <div class="d-flex justify-content-between">
                <button class="btn-pagination" *ngIf="!(pagination.skip == 0)" (click)="goPrevious()">
                  Anterior
                </button>
                <button class="btn-pagination" (click)="goNext()" *ngIf="skipPagination < pagination.total">
                  Próximo >>
                </button>
              </div>
            </div>
            <div class="center-load" *ngIf="loadVacancies && !error">
              <img src="assets/images/oval-page.svg" />
            </div>
          </section>

          <section id="companyVideo"
            *ngIf="company?.landingPage?.config?.showVideo == true && company?.landingPage?.video">
            <div class="center-object">
              <!-- <div class="row bg-video">
                <div class="col-12 bg-gray">
                </div>
              </div> -->
              <div class="row">
                <div class="col-12 video video-background">
                  <iframe height="315" [src]='safeURL' frameborder="0" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </section>

          <section *ngIf="!hiddenPage" id="companyAbout">
            <h3 #about [style.color]="company?.landingPage?.colors?.mainColor">Sobre a organização</h3>
            <p [innerHTML]="configText(company?.description)"></p>
          </section>
          <section *ngIf="!hiddenPage" id="company-mission">
            <h3 #mission [style.color]="company?.landingPage?.colors?.mainColor">Nossa missão</h3>
            <div class="row mission-container">
              <div class="col-12">
                <p class="quote-text" class="mission-content" [style.color]="company?.landingPage?.colors?.mainColor">
                  {{company?.mission}}</p>
              </div>
            </div>
            <div class="row" *ngIf="company?.whatWeDo">
              <div class="col-12 col-md-3">
                <h4 [style.color]="company?.landingPage?.colors?.mainColor">O que Fazemos</h4>
              </div>
              <div class="col-12 col-md-9">
                <p>{{company?.whatWeDo}}</p>

              </div>
            </div>
          </section>
          <section *ngIf="showPhotoGallery" id="gallery">
            <div class="container m-50-0">
              <div class="row">
                <div class="col-12">
                  <owl-carousel-o [options]="customOptions">
                    <ng-container *ngFor="let photo of gallery">
                      <ng-template carouselSlide [width]="500" [id]="photo.id">
                        <div class="">
                          <img [src]="photo.src" [alt]="photo.alt">
                        </div>
                      </ng-template>
                    </ng-container>

                  </owl-carousel-o>
                </div>
              </div>
            </div>

          </section>

          <section id="company-process">
            <h3 #process [style.color]="company?.landingPage?.colors?.mainColor">Processo seletivo</h3>
            <p>Em busca de inovar e oferecer uma experiência diferente e que agregue mais valor ao processo
              seletivo de seus
              futuros colaboradores, a empresa {{company?.fantasyName}} se tornou parceira do TAQE.
              Trata-se de um
              aplicativo que capacita
              e insere jovens a novas oportunidades.</p>
            <b>Tudo 100% gratuito e seguro!</b>
          </section>
          <section *ngIf="!hiddenPage" id="app">
            <div class="container">
              <div class="row">
                <div class="col-12 col-md-5 d-md-block d-none">
                  <img class="w-100" src="assets/images/smartphone_landingpage.png" alt="">
                </div>
                <div class="col-12 col-md-7 p-sm-30">
                  <div class="row">
                    <div class="col-8">
                      <h4 [style.color]="company?.landingPage?.colors?.mainColor">Descubra como é
                        fácil participar!</h4>
                    </div>
                  </div>

                  <ol [style.color]="company?.landingPage?.colors?.mainColor">
                    <li>Acesse pelo site: <a target="_blank" (click)="clickOnApplyButton()">{{ url_pwa }}</a></li>
                    <p>Disponível em qualquer navegador.
                      <!-- <b>Insira seu celular e nós enviamos o link para download:</b> -->
                    </p>
                    <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                      <button type="button" class="button-center-apply"
                        [ngStyle]="{'background': vacancy?.landingPage?.color}"
                        (click)="mobile ? goToDeeplink() : clickOnApplyButton()">
                        Conheça nossas oportunidades!
                      </button>
                    </div>
                    <!-- <div class="input-number-large" *ngIf="!sendLink">
                                            <img class="inl-img-phone" src="assets/images/icons/celular.svg">
                                            <input type="text" [(ngModel)]="cellphoneNumber"
                                                [textMask]="{ mask: cellphoneMask, guide: false }"
                                                placeholder="Seu celular" [disabled]="smsStatus.sending">
                                            <button type="button" class="template-button"
                                                [style.backgroundColor]="company?.landingPage?.colors?.mainColor"
                                                (click)="sendSMS()" [disabled]="smsStatus.sending">
                                                <img width="30" src="assets/images/icons/enviar-white.svg">
                                            </button>
                                        </div> -->

                    <div class="sent-link" *ngIf="sendLink">
                      <p>Link para download enviado! <img src="assets/images/icons/green-check.svg" alt=""></p>
                    </div>
                    <li>Faça testes interativos</li>
                    <p>Através deles você constrói seu perfil e revela o seu potencial.</p>

                    <li>Deu Match?</li>
                    <p>Complete as aulas e testes, preencha seus dados e descubra se o seu perfil
                      combina com o
                      perfil da oportunidade.</p>

                    <li>Candidate-se e boa sorte!</li>
                    <p>Combinou? Agora é só se candidatar e aguardar.</p>

                  </ol>
                </div>
              </div>
            </div>
          </section>


        </div>
      </div>
    </div>
    <app-footer [company]="company"></app-footer>
  </div>
  <div class="load" *ngIf="load && !error">
    <img src="assets/images/oval-page.svg" class="loading-icon" />
  </div>
  <div *ngIf="error">
    <app-not-found [message]="errorMessage"></app-not-found>
  </div>
</div>
